module.exports = __webpack_public_path__ + "static/img/codcw.021be52.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/games/games_colorful/codcw.svg
// module id = PaWb
// module chunks = 38